/* App */
export const IMAGE_RESIZER_URL = window?.etesting?.env?.IMAGE_RESIZER_URL;

/* BO */
export const CONFIG_BO = {
    BASE_URL: import.meta.env.BASE_URL,
    GOOGLE_CLIENT_ID: window?.etesting?.env?.GOOGLE_OAUTH_CLIENT_ID ?? import.meta.env.GOOGLE_OAUTH_CLIENT_ID,
};
